import { useRef } from 'react'

import { InputMode, InputTypeValue } from '../Input.constants'
import { InputField } from '../InputField'

import { normalizeIntegerInput } from './IntegerInput.utils'

function IntegerInput({
  getNormalizedIntegerInput = normalizeIntegerInput,
  max,
  min,
  transformValue,
  type = InputTypeValue.Text,
  value,
  onChange,
  ...restProps
}) {
  const ref = useRef(null)

  function handleChange(e) {
    onChange(getNormalizedIntegerInput({ max, min, value: e.target.value }))
  }

  const inputValue = transformValue?.(value) ?? value

  return (
    <InputField
      {...restProps}
      inputProps={{
        inputMode: InputMode.Numeric,
      }}
      ref={ref}
      type={type}
      value={inputValue}
      onChange={handleChange}
    />
  )
}

export default IntegerInput
